import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getInstallationProcessUseCase = async (update_id: string) => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;

    const response = await apiUseCases.getInstallationProcess(
      namespace,
      update_id,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch installation process")
        .message,
    };
  }
};
